import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Header } from 'pages/HomePublic/components/Header';
import { StepIndicator } from 'components/ui/StepIndicator';
import { HiUsers } from 'react-icons/hi';
import { BsCameraVideoFill } from 'react-icons/bs';
import { IoCheckmarkCircle } from 'react-icons/io5';
import { useControlDate } from 'hooks/useControlDate';
import { PHASE_IDS } from 'utils/constants';
import DateRangeDisplay from 'components/ui/DateRangeDisplay';
import { useModal } from 'context/ModalContext/Modal.context';
import { ParticipationConfirmedModal } from 'components/ui/ParticipationConfirmedModal';
import envelope from 'assets/img/2026/envelope.png';

const threeSteps = [
  { icon: BsCameraVideoFill as React.FunctionComponent<React.SVGProps<SVGSVGElement>>, number: 1, activeColor: 'bg-green-bb-2', iconColor: 'text-pink-bb-1' },
  { icon: HiUsers as React.FunctionComponent<React.SVGProps<SVGSVGElement>>, number: 2, activeColor: 'bg-green-bb-2', iconColor: 'text-pink-bb-1' },
  { icon: IoCheckmarkCircle as React.FunctionComponent<React.SVGProps<SVGSVGElement>>, number: 3, activeColor: 'bg-green-bb-2', iconColor: 'text-pink-bb-1' },
];

export function ConfirmacaoPremio() {
  const navigate = useNavigate();
  const { showModal, closeModal } = useModal();
  const periodoConfirmacao = useControlDate(PHASE_IDS.CONEXAO_CONFIRMATION);

  useEffect(() => {
    showModal(
      'participation-confirmed',
      <ParticipationConfirmedModal onClose={closeModal} />,
      'participation-confirmed-wrapper',
    );
  }, [closeModal, showModal]);

  return (
    <div className="min-h-screen bg-gray-100">
      <Header currentPage="minhas-iniciativas" />

      {/* Step indicator — todas as etapas ativas */}
       <div className="py-6 mt-8">
        <div className="max-w-[1200px] mx-auto px-4">
          <StepIndicator currentStep={3} steps={threeSteps} progressColor="bg-green-bb-2" />
        </div>
      </div>

      <main className="px-4 py-12 pb-20">
        <div className="max-w-[1200px] mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            {/* Coluna esquerda — texto */}
            <div className="flex flex-col gap-5">
              <h1 className="text-4xl font-bold text-blue-bb-1 leading-snug m-0">
                A inscrição da sua iniciativa foi confirmada no <span className='text-pink-bb-1'>Prêmio BB 2026!</span>
              </h1>

              <p className="text-xl text-gray-600 m-0">
                {periodoConfirmacao ? (
                  <>
                    De <DateRangeDisplay
                      dataInicio={periodoConfirmacao.dataInicio}
                      dataFim={periodoConfirmacao.dataFim}
                      dateFormat="dd/MM"
                      className="font-semibold"
                    /> será realizada a primeira etapa de votação.
                  </>
                ) : (
                  'Em breve será realizada a primeira etapa de votação.'
                )}
              </p>

              <p className="text-xl text-gray-600 m-0">
                Todos os demais funcionários cadastrados como participantes da iniciativa serão acionados via e-mail para: <br/> 1) confirmar sua participação no Prêmio BB; <br/> 2) aderir ao Regulamento da premiação e; <br/>3) caso participe de iniciativa ECBB/Joga Junto, votar nos 5 participantes que poderão ser contemplados com o prêmio individual, caso a iniciativa seja premiada na última etapa de avaliação. 
              </p>

              <p className="text-xl font-semibold text-pink-bb-1 m-0">
                Fique ligado, e não perca o prazo da votação.
              </p>

              <p className="text-xl text-gray-600 m-0">
                O resultado da primeira etapa de avaliação sai no dia{' '}
                {periodoConfirmacao?.dataFim ? (
                  <DateRangeDisplay
                    dataInicio={new Date(new Date(periodoConfirmacao.dataFim).getTime() + 2 * 24 * 60 * 60 * 1000)}
                    dateFormat="dd/MM"
                    className="font-semibold"
                  />
                ) : (
                  <span className="font-semibold">em breve</span>
                )}!
              </p>

              <button
                className="bg-yellow-bb text-blue-bb border-0 rounded-lg px-8 py-3 text-sm font-extrabold cursor-pointer hover:bg-[#e6b800] transition-colors self-start mt-2"
                onClick={() => navigate('/minhas-iniciativas')}
              >
                VER INICIATIVAS
              </button>
            </div>

            {/* Coluna direita — ilustração */}
            <div className="flex items-center justify-center">
              <div className="relative w-96 h-96">
                <div className="rounded-2xl flex items-center justify-center">
                  <img src={envelope} alt="Envelope" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
